import * as React from "react";
import { useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Modal } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ListItemIcon from "@mui/material/ListItemIcon";
import LogoutIcon from "@mui/icons-material/Logout";
import Storages from "../helpers/localStorage";
import PersonIcon from "@mui/icons-material/Person";
import RefreshIcon from "@mui/icons-material/Refresh";
import config from "../config";
import { useContext } from "react";
import { UserContext } from ".";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function PersistentDrawerLeft({ setOpen, open }) {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const theme = useTheme();
  let navigate = useNavigate();
  const location = useLocation();
  // let user = JSON.parse(localStorage.getItem("QCAPPuser"));
  const user = useContext(UserContext);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleModalLogOut = () => {
    setOpenModal(true);
  };

  const onLogout = () => {
    Storages.deleteStorage("QCAPPuser");
    Storages.deleteStorage("QCAPPjwt");
    Storages.deleteStorage("ESSjwt");
    sessionStorage.clear();
    navigate("/login");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openProfile = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className="flex w-screen bg-[#3936f3]">
      <CssBaseline />
      <AppBar position="relative" open={open}>
        <Toolbar className="flex  flex-row bg-colorMain justify-between">
          {/* <div> */}
          <div className="flex flex-row justify-between">
            <div className="flex items-center ">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{ mr: 2, ...(open && { display: "none" }) }}
              >
                <MenuIcon />
              </IconButton>
            </div>
            <div className="flex items-center ">
              <Typography variant="h6" noWrap component="div">
                QC APP
              </Typography>
            </div>
          </div>
          <div>
            <IconButton
              className="bg-colrSub text-white mr-2"
              onClick={() => window.location.reload()}
            >
              <RefreshIcon />
            </IconButton>
            <Button
              className="bg-gray-500"
              variant="contained"
              onClick={handleClick}
              endIcon={<KeyboardArrowDownIcon />}
            >
              {user.profile_image !== null ? (
                <Avatar src={user.profile_image.url} />
              ) : (
                <div className="flex justify-center items-center">
                  <PersonIcon />
                </div>
              )}
              <span className="ml-2">{`${user.qc_role}`}</span>
            </Button>
          </div>
          <Menu
            // id="fade-menu"
            // MenuListProps={{
            //   "aria-labelledby": "fade-button",
            // }}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            anchorEl={anchorEl}
            open={openProfile}
            onClose={handleClose}
            // TransitionComponent={Fade}
          >
            <Link key={"profile"} to={`/layout/profile/${user.id}`}>
              <MenuItem>
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                Profile
              </MenuItem>
            </Link>
            {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
            <MenuItem key={"Logout"} onClick={handleOpenModal}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 4,
            p: 4,
          }}
        >
          <Typography
            id="modal-modal-title"
            variant="h7"
            component="h2"
            fontWeight="regular"
          >
            ยืนยันที่จะออกจากระบบใช่ หรือ ไม่
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={2}
          >
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                onLogout();
                handleCloseModal();
              }}
            >
              ตกลง
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCloseModal}
              style={{ marginLeft: "8px" }}
            >
              ยกเลิก
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
